import useCreate from "@/hooks/use-create";
import { UseLoadingReturn } from "@/hooks/use-loading";
import { IServiceHoursInput } from "@/interfaces/service-hours.interface";
import serviceHoursService from "@/services/service-hours.service";
import { RequestsProps } from "@/types/requests.types";

export type Props = {
  formData: IServiceHoursInput;
} & RequestsProps;

export type Return = {
  create: (props: Props) => Promise<void>;
} & UseLoadingReturn;

const useCreateServiceHours = (): Return => {
  const { isLoading, startLoading, endLoading, loadingIcon, create } = useCreate<IServiceHoursInput>({
    operation: (formData) => serviceHoursService.create(formData),
  });

  return { isLoading, startLoading, endLoading, loadingIcon, create };
};

export default useCreateServiceHours;
